import { EmptyState, FlexColumn, FlexRow, Loading, MaterialIcon, StyledButton } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { HeadingSmall } from 'baseui/typography';
import { generatePath, useNavigate } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { LIVE_PAGE } from '../../../constants/app';
import { useStyles } from '../../../hooks/useStyles';
import { workspaceState } from '../../../storage/app';
import { loadingCurrentStatesState } from '../../../storage/currentStates';
import { capturingCurrentStateState, capturingState } from '../../../storage/streaming';
import LocalizedDatePicker from '../../shared/LocalizedDatePicker';
import { StyledTooltip } from '../../ui/StyledTooltip';
import CurrentStateBasicHeader from '../CurrentStateBasicHeader';
import CapturingVideoTrackList from './capturingVideo/CapturingVideoTrackList';
import CapturingTimelineProvider from './providers/CapturingTimelineProvider';

function CapturingVideoDetail() {
  const { theme, css } = useStyles();
  const [capturingData, setCapturingData] = useRecoilState(capturingState);
  const { selectedDate } = capturingData;
  const currentState = useRecoilValue(capturingCurrentStateState);
  const workspace = useRecoilValue(workspaceState);
  const navigate = useNavigate();
  const loading = useRecoilValue(loadingCurrentStatesState);

  const onDateChange = (date: Date) => {
    setCapturingData((prev) => ({
      ...prev,
      selectedDate: date.getTime(),
    }));
  };

  const onCloseCapturing = () => {
    const route = generatePath(LIVE_PAGE.route, { id: workspace?._id });
    navigate(route, { replace: true });
  };

  if (loading) {
    return <Loading />;
  }

  if (!currentState) {
    return (
      <EmptyState
        title="Dispositivo no encontrado"
        action={
          <StyledButton
            shape="pill"
            onClick={onCloseCapturing}
          >
            Volver al inicio
          </StyledButton>
        }
        style={{ gap: theme.sizing.scale600 }}
      />
    );
  }

  return (
    <>
      <FlexRow classNames={css({ justifyContent: 'space-between', alignItems: 'center' })}>
        <HeadingSmall margin={0}>Solicitar video</HeadingSmall>
        <FlexRow
          centered
          gap={theme.sizing.scale200}
        >
          <StyledTooltip
            content="Cerrar"
            showArrow={false}
          >
            <Button
              shape="circle"
              kind="tertiary"
              size="compact"
              onClick={onCloseCapturing}
            >
              <MaterialIcon
                name="close"
                size="mini"
              />
            </Button>
          </StyledTooltip>
        </FlexRow>
      </FlexRow>
      <FlexColumn classNames={css({ overflowY: 'auto', flex: 1 })}>
        <CurrentStateBasicHeader currentState={currentState} />
        <LocalizedDatePicker
          value={[new Date(selectedDate)]}
          formatString="dd MMMM yyyy"
          onChange={({ date }) => {
            if (date && !(date instanceof Array)) {
              onDateChange(date);
            }
          }}
          onClose={() => {
            onDateChange(new Date(selectedDate));
          }}
          size="compact"
          maxDate={new Date()}
          overrides={{
            Input: {
              props: {
                startEnhancer: 'Fecha:',
                overrides: {
                  StartEnhancer: {
                    style: {
                      paddingLeft: 0,
                      paddingRight: 0,
                      fontWeight: '600',
                    },
                  },
                },
              },
            },
          }}
        />
        <CapturingTimelineProvider />
        <CapturingVideoTrackList />
      </FlexColumn>
    </>
  );
}

export default CapturingVideoDetail;
